const DEFAULT_TIMEOUT = 5000;

const state = {
  content: '',
  color: '',
  timeout: DEFAULT_TIMEOUT,
};

const mutations = {
  showNotification(state, payload) {
    state.content = payload.content;
    state.color = payload.color;
    // A longer message can ask for more reading time.
    state.timeout = payload.timeout ?? DEFAULT_TIMEOUT;
  },
};

export default {
  state,
  mutations,
};
